import {Component, Inject, OnInit} from '@angular/core';
import {UserService} from '../../../shared/user.service';
import {ApiService} from '../../../api/api.service';
import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import {Moment} from 'moment';
import {CookieService} from 'ngx-cookie';
import {LOCATION_SERVICE} from '../../../shared/upgrade/location.service';
import {NotificationsService} from '../notifications.service';
import {Notifications} from '../notifications.enum';
import {EmployeeType} from '../../../settings/settings-employees/settings-employees.component';
import {
	EmployeeEditHistoryDetails,
	EmployeesEditHistoryCacheService
} from '../../../core/employee-edit-history-cache.service';
import {TimecardBuilderService, TimecardPeriod, VIEW_DATE_FORMAT} from '../../../reports/timecards-builder.service';
import {NyTzMoment} from '../../../shared/ny-tz-moment.service';
import {EmployeeEditHistoryEntry} from 'resteasytox';

interface Timecard {
	paymentFrequency?: string;
	employees?: string[];
	startDate: string;
	endDate: string;
	user?: string;
}
interface TimecardRange {
	startDate: Moment;
	endDate: Moment;
}

@Component({
	selector: 'tt-employee-unsubmitted-timecard-notification',
	templateUrl: './employee-unsubmitted-timecard-notification.component.html',
	styleUrls: ['./employee-unsubmitted-timecard-notification.component.scss']
})
export class EmployeeUnsubmittedTimecardNotificationComponent implements OnInit {
	public EMPLOYEE_TYPE: any = EmployeeType;
	public unsubmittedTimecards: Timecard[] = [];
	private readonly cookieName: string = 'timecardsState';
	constructor(private notificationsService: NotificationsService,
				private userService: UserService,
				private apiService: ApiService,
				private employeesHistoryService: EmployeesEditHistoryCacheService,
				// @Inject('$rootScope') private rootScopeService: angular.IRootScopeService,
				private cookieService: CookieService,
				private timecardBuilderService: TimecardBuilderService,
				private nyTzMoment: NyTzMoment,
				@Inject(LOCATION_SERVICE) private locationService: angular.ILocationService) {

		// this.rootScopeService.$on('userDetailsLoaded',
		// 	(e: angular.IAngularEvent, user: User) => {
		// 		if (user && user.payType === 'daily' && !user.qbAdmin) {
		// 			this.updateNotification();
		// 		}
		// 	});

	}

	ngOnInit(): void {
		const employeeDetails: EmployeeEditHistoryDetails = this.employeesHistoryService.getEmployeeDetailsAtDate(this.userService.user.id, Date.now());
		if (employeeDetails) {
			if ( (employeeDetails.employeeType === EmployeeType.DAILY_1099 || employeeDetails.employeeType === EmployeeType.DAILY_W2 ) && !this.userService.user.qbAdmin) {
				this.updateNotification();
			}
		}
	}

	public goToTimeCard(timecard: Timecard): void {
		const s: Moment = this.nyTzMoment.create(timecard.startDate, VIEW_DATE_FORMAT);
		const e: Moment = this.nyTzMoment.create(timecard.endDate, VIEW_DATE_FORMAT);
		const paymentFrequency: string = (e.diff(s, 'days') > 14) ? 'monthly' : 'bi-weekly';

		const data: any = {
			paymentFrequency: paymentFrequency,
			employees: [this.userService.user.id],
			startDate: timecard.startDate,
			endDate: timecard.endDate,
			user: this.userService.user.loginName
		};

		this.cookieService.putObject(this.cookieName, data, {
			expires: moment().add(90, 'days').toDate()
		});

		this.cookieService.putObject('selectedTimecardsEmployeesNG2', { employees: data.employees }, {
			expires: moment().add(90, 'days').toDate()
		});

		this.locationService.path('/timecardsReportNew');
	};

	public closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.EMPLOYEE_UNSUBMITTED_TIMECARD_NOTIFICATION);
	}

	public isVisible(): boolean {
		return this.notificationsService.isNotificationAvailable(Notifications.EMPLOYEE_UNSUBMITTED_TIMECARD_NOTIFICATION);
	}

	// Private methods
	private updateNotification(): void {
		const employeeHistory: EmployeeEditHistoryEntry[] = this.employeesHistoryService.getEmployeeEditHistory(this.userService.user.id);
		if (!employeeHistory.length) { alert('Empty employee edit history'); return; }

		const startDate: Moment = this.nyTzMoment.create(employeeHistory[0].startDate);
		const endDate: Moment = this.nyTzMoment.create();

		this.apiService.getSubmittedTimecards({
			startDate: startDate.format('MM/DD/YYYY'),
			endDate: endDate.format('MM/DD/YYYY'),
			employees: [this.userService.user.id]
		}).subscribe(
			(submittedTimecards: Timecard[]) => {
				const unsubmittedTimecards: any[] = [];
				const timecardsRanges: TimecardPeriod[] = this.timecardBuilderService.generateEmployeeTimecardsPeriodsForPeriod(startDate.valueOf(), endDate.valueOf(), this.userService.user);

				timecardsRanges.forEach((range: TimecardPeriod) => {
					if (!this.isTimecardSubmitted(range, submittedTimecards)) {
						unsubmittedTimecards.push({
							startDate: range[0],
							endDate: range[1]
						});
					}
				});

				this.unsubmittedTimecards = unsubmittedTimecards;
			});

		// switch (this.userService.user.paymentFrequency) {
		// 	case 'monthly':
		// 		startDate = moment(this.userService.user.startWork);
		// 		endDate = moment().subtract('1', 'month').endOf('month');
		//
		// 		break;
		// 	case 'bi-weekly':
		// 		const now: Moment = moment();
		// 		startDate = moment(this.userService.user.startWork);
		// 		const iterator: Moment = startDate.clone();
		// 		while (iterator.add(2, 'weeks').diff(now) < 0) {}
		// 		endDate = iterator.subtract(2, 'weeks');
		// 		this.apiService.getSubmittedTimecards({
		// 			startDate: startDate.format('MM/DD/YYYY'),
		// 			endDate: endDate.format('MM/DD/YYYY'),
		// 			employees: [this.userService.user.id],
		// 			paymentFrequency: this.userService.user.paymentFrequency
		// 		}).subscribe(
		// 			(submittedTimecards: Timecard[]) => {
		// 				this.unsubmittedTimecards = this.generateUnsubmittedTimecards(submittedTimecards, startDate, endDate, 'bi-weekly');
		// 			});
		// 		break;
		// }

	}
	// private generateUnsubmittedTimecards(
	// 	submittedTimecards: Timecard[],
	// 	startDate: Moment,
	// 	endDate: Moment,
	// 	paymentFrequency: 'bi-weekly' | 'monthly'): Timecard[] {
    //
	// 	const unsubmittedTimecards: Timecard[] = [];
    //
	// 	// get all ranges for selected period
	// 	let timecardRanges: TimecardRange[] = [];
	// 	for (let year: number = startDate.year(); year <= endDate.year(); year++) {
	// 		if (paymentFrequency === 'bi-weekly') {
	// 			timecardRanges = timecardRanges.concat(this.generateBiweeklyTimecardsRangesForYear(year));
	// 		} else {
	// 			timecardRanges = timecardRanges.concat(this.generateMonthlyTimecardsRangesForYear(year));
	// 		}
	// 	}
    //
	// 	// remove ranges earlier than startDate and older than endDate
	// 	timecardRanges = _.filter(timecardRanges, (timecardRange: TimecardRange) => {
	// 		return (
	// 			(timecardRange.startDate.isSameOrAfter(startDate) || (timecardRange.startDate.isBefore(startDate) && timecardRange.endDate.isAfter(startDate)))
	// 			&& timecardRange.endDate.isSameOrBefore(endDate)
	// 		);
	// 	});
    //
	// 	// filter submitted timecards
	// 	timecardRanges.forEach((range: TimecardRange) => {
	// 		if (!this.isTimecardSubmitted(range, submittedTimecards)) {
	// 			unsubmittedTimecards.push({
	// 				startDate: range.startDate.format('MM/DD/YYYY'),
	// 				endDate: range.endDate.format('MM/DD/YYYY')
	// 			});
	// 		}
	// 	});
    //
	// 	return unsubmittedTimecards;
	// }

	private isTimecardSubmitted(timecardPeriod: TimecardPeriod, submittedTimecards: Timecard[]): boolean {
		return _.some(submittedTimecards, (timecard: Timecard) => {
			return (timecard.startDate === timecardPeriod[0] && timecard.endDate === timecardPeriod[1]);
		});
	}


	private generateBiweeklyTimecardsRangesForYear(year: number): TimecardRange[] {
		let sDate: Moment = moment('1/1/' + year, 'MM/DD/YYYY');
		const timecards: TimecardRange[] = [];

		// all be-weekly timcards starts from Monday
		while (sDate.day() !== 1) {
			sDate.add(1, 'day');
		}

		let fDate: Moment = sDate.clone().add(13, 'days');
		do {
			timecards.push({ startDate: sDate, endDate: fDate });
			sDate = fDate.clone().add(1, 'days');
			fDate = sDate.clone().add(13, 'days');
		} while (sDate.year() <= year);

		return timecards;
	}

	private generateMonthlyTimecardsRangesForYear(year: number): TimecardRange[] {
		let sDate: Moment = moment('1/1/' + year, 'MM/DD/YYYY');
		const timecards: TimecardRange[] = [];

		let fDate: Moment = sDate.clone().endOf('month');
		do {
			timecards.push({ startDate: sDate, endDate: fDate });
			sDate = fDate.clone().add(1, 'days');
			fDate = sDate.clone().endOf('month');
		} while (sDate.year() <= year);

		return timecards;
	}

}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/employee-unsubmitted-timecard-notification/employee-unsubmitted-timecard-notification.component.ts